// utils/axiosInstance.js
import axios from "axios";
import { useSelector } from "react-redux";
import { useMemo } from "react";

const useHotelApi = () => {
  const token = localStorage.getItem("accessToken");

  const HotelApi = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      withCredentials: true,
    });

    instance.interceptors.request.use((config) => {
      // Attach token if exists
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // ✅ Attach frontend location
      if (typeof window !== "undefined") {
        config.headers["x-frontend-location"] = window.location.href;
      }

      return config;
    });

    return instance;
  }, [token]); // re-create instance when token changes

  return HotelApi;
};

export default useHotelApi;
